const stagingStores = [
  {
    id: "LTDEGMSS9STVH",
    name: "Kahana Gateway  Store"
  },
  {
    id: "LEB2FAA5HS4BN",
    name: "Kapaa Store"
  },
  {
    id: "LT3VVR9KEAMR5",
    name: "Koloa Store"
  },
  {
    id: "L7782J4YTV1N2",
    name: "Oahu (Honolulu) Store"
  },
  {
    id: "L6YS762RR8HHN",
    name: "SB_96 Maui DC"
  }
]

const productionStores = [
  {
      name: "SB001 Kapaa",
      id: "WY2CNWG35F870"
  },
  {
      name: "SB002 Kona",
      id: "R4KG9BM3JKGFP"
  },
  {
      name: "SB003 Waikoloa",
      id: "L07J1ZQ597A3G"
  },
  {
      name: "SB004 Oahu",
      id: "AAFEQ6MHTVSVK"
  },
  {
      name: "SB006 Kihei",
      id: "2S7CEZ6YMN35S"
  },
  {
      name: "SB007 Napili",
      id: "X7TM62YQ4QRNY"
  },
  {
      name: "SB008 Koloa",
      id: "WVEEXQF1C3QEB"
  },
  {
      name: "SB009 Azeka",
      id: "23QPQ4W8039D9"
  },
  {
      name: "SB010 Lahaina",
      id: "GZ1AG5WJ3WV7J"
  },
  {
      name: "SB012 Honokowai",
      id: "993Z99SXCQAZK"
  },
  {
      name: "SB013 Mauna Lani",
      id: "94WSN92JV6XJQ"
  },
  {
      name: "SB014 Wailea",
      id: "2JG2DE4MJRV75"
  },
  {
      name: "SB015 Kahana",
      id: "QZMHC1RD30A2J"
  },
  {
      name: "SB_96 Maui DC",
      id: "QT5NA31NCGBR7"
  },
  {
      name: "SB_99 Online Store",
      id: "4XF0DEY37RTKJ"
  }
]

export default {
  production: productionStores,
  staging: stagingStores,
  development: stagingStores
}